import { Service, request, setUserAuthInfo } from '../../../index';
import { CampAccount } from '../types';

interface CampLoginReq {
  channelId: number;
  openId: string;
  token: string;
}

interface CampIntlCheckReq {
  channelInfo: string;
  channelId: number;
}

class LoginService extends Service {
  intlCheck = async (params: CampIntlCheckReq) => {
    const resp = await request<CampAccount>({
      url: '/game/user/checkopenid',
      data: params,
    });
    return resp.code === 0 ? this.success({ data: resp.data }) : this.fail({ code: resp.code, message: resp.message });
  };
  campLogin = async (params: CampLoginReq, cache: boolean) => {
    console.log('loginparams', params);
    const data = {
      ...params,
      token: (window as any).__TCSJ__.rsaEncrypt(params.token),
      gameId: '29134',
    };
    const headers = { specialEncodeParam: (window as any).__TCSJ__.getEncodeParam() };

    const resp = await request({
      url: '/game/user/checkroleandlogin',
      data,
      headers,
    });
    console.log('resp', resp);

    if (resp.data?.encryption) {
      (window as any).__TCSJ__.setLoginRes(resp.data.encryption);
    }
    if (resp.data?.role) {
      setUserAuthInfo(resp.data.role.uid, resp.data.campToken, resp.data.role, cache);
    }
    return resp.code === 0 ? this.success({ data: resp.data }) : this.fail({ code: resp.code, message: resp.message });
  };
}

export const service = new LoginService();
